import { useState } from "react";

import useAuthenticatedUser from "@libs/acp/hooks/useAuthenticatedUser";
import { identityResubEmail } from "@libs/acp/apis/updateAccount/updateAccountAPI";

import { useTracking } from "@libs/acp/hooks/useTracking";
import { FormTypeEnum } from "@libs/acp/flows/types";

export const useEmailResubscriptionSwitch = () => {
	const { userAttributeUpdatedEvent, elementClickedEvent } = useTracking(
		FormTypeEnum.UPDATE_CONTACT,
	);

	const { authenticatedUser, updateACPUSerContactStatus } =
		useAuthenticatedUser();

	const [isActiveResubSwitch, setIsActiveResubSwitch] =
		useState<boolean>(false);

	const [resubStatus, setResubStatus] = useState<
		"idle" | "loading" | "success" | "error"
	>("idle");

	const hasUnsubscribedCommunication =
		authenticatedUser?.customer?.contactStatus?.email?.unsub;

	const resubscribeCustomerEmail = async () => {
		setResubStatus("loading");
		setIsActiveResubSwitch(true);

		elementClickedEvent({
			elementType: "card",
			location: window.location.pathname,
			text: "Quero receber notificações sobre novidades e lembretes via e-mail.",
			name: "resubEmail",
		});

		try {
			const { data } = await identityResubEmail();

			setResubStatus("success");

			const { id, email, document } = authenticatedUser.customer;

			userAttributeUpdatedEvent({
				devedorId: id,
				customerEmail: email,
				customerId: document,
				key: "unsub",
				newValue: "false",
				oldValue: "true",
			});

			const initialDefaultContactStatus = {
				unsub: false,
				bounced: false,
				blocked: false,
				neverEngaged: false,
				customer_engagement_status: "",
				expires: 0, // +1 hour
			};

			const contactStatus =
				authenticatedUser?.customer?.contactStatus.email ||
				initialDefaultContactStatus;

			updateACPUSerContactStatus("email", {
				...contactStatus,
				unsub: false,
				expires: Date.now() + 60 * 60 * 1000, // +1 hour
			});

			return data;
		} catch (err) {
			setResubStatus("error");
			setIsActiveResubSwitch(false);

			setTimeout(() => {
				setResubStatus("idle");
			}, 4000);

			console.error(err);
		}
	};

	const handleResubscribeCommunication = async () => {
		await resubscribeCustomerEmail();
	};

	return {
		isActiveResubSwitch,
		hasUnsubscribedCommunication,
		resubStatus,
		handleResubscribeCommunication,
	};
};
